import { getApiClient, initializeApiClient } from "../../apiService";

const UpdateSectoreInformationProject = async (
  sO_sectorAndProjectOriginalityInfoId,
  competitorsIdentification,
  distinguishingFeaturesOfApplicant,
  reasonsSupportingFundingDecision,
  aI_ApplicationInformationId
) => {
  await initializeApiClient();
  const apiClient = await getApiClient();
  const response = await apiClient.post(
    `/api/SO_sectorAndProjectOriginalityInfo/UpdatesectorAndProjectOriginality`,
    {
      sO_sectorAndProjectOriginalityInfoId:
        sO_sectorAndProjectOriginalityInfoId,
      competitorsIdentification: competitorsIdentification,
      distinguishingFeaturesOfApplicant: distinguishingFeaturesOfApplicant,
      reasonsSupportingFundingDecision: reasonsSupportingFundingDecision,
      aI_ApplicationInformationId: aI_ApplicationInformationId,
    }
  );

  return response.data.result;
};

export default UpdateSectoreInformationProject;
